import React, { useState, useEffect } from 'react';
import '../styles/domain.css';
import icannLogo from '../assets/icann-logo.png';
import backgroundImage from '../assets/domain-bg.jpg';

function Domains() {
  const [domainName, setDomainName] = useState('');
  const [selectedTLD, setSelectedTLD] = useState('');
  const [tldOptions, setTldOptions] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Load TLDs from working Blesta MySQL endpoint (Safari-safe)
  useEffect(() => {
    fetch('https://i-word.net/api/tlds-new.php')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          // ✅ Force Safari to repaint with setTimeout trick
          setTimeout(() => setTldOptions(data), 0);
        } else {
          console.error('TLD response malformed:', data);
        }
      })
      .catch((err) => {
        console.error('TLD fetch error:', err);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    if (!domainName || !selectedTLD) {
      setResult({ success: false, message: 'Please enter a domain and select a TLD.' });
      setLoading(false);
      return;
    }

    const fullDomain = `${domainName}${selectedTLD}`;

    try {
      const response = await fetch('https://i-word.net/api/check-domain.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `domain=${encodeURIComponent(fullDomain)}`
      });

      const data = await response.json();

      if (data.available === true) {
        const redirectUrl = `https://account.i-word.net/order/config/preconfig/register_domain?domain=${encodeURIComponent(fullDomain)}`;
        window.location.href = redirectUrl;
      } else {
        setResult({ success: true, available: false });
      }
    } catch (error) {
      console.error("Error checking domain:", error);
      setResult({ success: false, message: 'Something went wrong. Try again.' });
    }

    setLoading(false);
  };

  return (
    <div className="domain-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="domain-overlay">
        <div className="domain-content">
          <h1 className="domain-title">Domain Search</h1>
          <p className="domain-subtitle">Bookmark our #1 Domain Search on the W3.</p>

          <form className="domain-search-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter your domain name"
              className="domain-input"
              value={domainName}
              onChange={(e) => setDomainName(e.target.value)}
              required
            />

            <select
              className="domain-tld-select"
              value={selectedTLD}
              onChange={(e) => setSelectedTLD(e.target.value)}
              required
              style={{
                padding: '10px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
                color: '#000',
                WebkitAppearance: 'menulist-button',
                appearance: 'menulist-button',
                width: '120px',
                cursor: 'pointer'
              }}
            >
              <option value="">TLD's</option>
              {tldOptions.map((tld, idx) => (
                <option key={`tld-${idx}`} value={tld}>
                  {tld}
                </option>
              ))}
            </select>

            <button type="submit" className="domain-search-button" disabled={loading}>
              {loading ? 'Checking...' : 'Search'}
            </button>
          </form>

          {result && !result.success && (
            <div className="domain-result">
              <p style={{ color: 'red' }}>{result.message}</p>
            </div>
          )}

          {result && result.success && !result.available && (
            <div className="domain-result">
              <p style={{ color: 'orange' }}>❌ {domainName}{selectedTLD} is already taken.</p>
            </div>
          )}

          <div className="domain-logo-container">
            <img src={icannLogo} alt="ICANN" className="domain-logo" />
          </div>

          <p className="domain-bookmark-note">
            📌 If domain is unavailable, refresh this page before your next domain search!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Domains;
